import { selector } from 'lib/selectors';
import { companyExperimentalBrainEnabledSelector } from 'domain/companies/companiesSelector';
import * as ACL from 'domain/restriction';

// Single feature-availability gate for the new brain document-categorization UI
// (type tabs, Inbox sub-type chips, reclassify). Every new surface consults this
// selector (design D5). Shown only when the company has `experimental_brain` enabled
// AND the user is a Bookkeeper.
//
// "Bookkeeper" == the accountant role family (plain / limited / restricted / read-only).
// `ACL.IS_ACCOUNT` is a policy over all four accountant rights, and the base
// `IS_ACCOUNT` right is granted to every accountant regardless of modificator — so
// `isGranted(ACL.IS_ACCOUNT)` matches the whole family. This holds as long as
// limited/restricted/readonly stay role *modificators* on top of `role === accountant`
// (see `myRestriction` in domain/restriction) rather than distinct role values.
export const brainCategorizationEnabledSelector = selector<unknown, boolean>(
  companyExperimentalBrainEnabledSelector,
  ACL.isGranted,
  (isBrainEnabled: boolean, isGranted: (rule: string) => boolean): boolean =>
    isBrainEnabled && isGranted(ACL.IS_ACCOUNT),
);
